import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import reduxUtils from '../../../util/redux';

class Title extends PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        openModal: PropTypes.func.isRequired,
    };

    onClick = () => {
        this.props.openModal({ layout: 'zip-form' });
    };

    render() {
        const { title, subtitle } = this.props;
        return (
            <div className="cms-title">
                <h1 className="cms-title--title u-reset">
                    <span className="cms-title--title-inner">
                        <span className="cms-title--title-text">{title}</span>
                    </span>
                    <span className="cms-title--title-inner cms-title--title-inner__shadow">
                        <span className="cms-title--title-shadow">{title}</span>
                    </span>
                </h1>
                <h2 className="cms-title--subtitle u-reset">
                    <span className="cms-title--subtitle-inner">
                        <span className="cms-title--subtitle-text">{subtitle}</span>
                    </span>
                    <span className="cms-title--subtitle-inner cms-title--subtitle-inner__shadow">
                        <span className="cms-title--subtitle-inner cms-title--subtitle-shadow">{subtitle}</span>
                    </span>
                </h2>
            </div>
        );
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        pageName: 'router.name',
    }),
    reduxUtils.mapDispatchToProps({
        openModal: 'modal.open',
    }),
)(Title);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/title/index.js